import React from 'react'
import * as styles from '../search.control.styl'
import cx from 'classnames'
import { invalidInput } from '@src/redux/reducers/autocomplete.query'

export interface SuggestionProps {
  item: string
  index?: number
  onfocus: boolean
  onMouseOver: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onClickSuggestion: (
    value: string,
    event?: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void
}

export const Suggestion: React.FC<SuggestionProps> = ({
  item,
  index,
  onfocus,
  onClickSuggestion,
  onMouseOver
}: SuggestionProps) => {
  function memoizedHandleClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) {
    onClickSuggestion(item, event)
  }
  return (
    <div
      data-role={`suggestion`}
      data-index={index}
      className={cx(styles.category, {
        [styles.invalid]: item === invalidInput,
        [styles.focus]: onfocus
      })}
      onClick={memoizedHandleClick}
      onMouseOver={onMouseOver}
    >
      {item}
    </div>
  )
}

export interface FilterSuggestionsProps {
  searchData: string[]
  focusIndex: number
  onMouseOver: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onClickSuggestion: (
    value: string,
    event?: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void
}

export const FilterSuggestions: React.FC<FilterSuggestionsProps> = ({
  searchData,
  focusIndex,
  onMouseOver,
  onClickSuggestion
}: FilterSuggestionsProps) => {
  if (!searchData) {
    return null
  }

  const filteredItems = searchData || []

  return (
    <div data-role={'suggestions'} className={styles.suggestions}>
      {filteredItems.length && filteredItems[0] !== invalidInput ? (
        <div data-role={'suggestionsHeader'} className={styles.header}>
          Suggested Category:
          <span data-role={'suggestionsCount'}>
            {filteredItems.length} results
          </span>
        </div>
      ) : null}
      <div data-role={'suggestionsList'} className={styles.data}>
        {filteredItems.map((item, index) => (
          <Suggestion
            key={index}
            index={index + 1}
            item={item}
            onfocus={index === focusIndex}
            onMouseOver={onMouseOver}
            onClickSuggestion={onClickSuggestion}
          />
        ))}
      </div>
    </div>
  )
}
